
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
  "pinLabel": "נעיצה",
  "find_label": "איתור",
  "findCancelLabel": "ביטול",
  "sourcePaneLabel": "מקורות שנבחרו",
  "addDataDashboardCoachMarkContents": "גררו ושחררו נתונים מחלונית הנתונים אל לוח המחוונים שלכם.",
  "addDataStoryCoachMarkContents": "גררו ושחררו נתונים מחלונית הנתונים אל הסיפור שלכם.",
  "addDataCoachMarkTitle": "הוספת נתונים",
  "noSourcesSelectedLabel": "לא נבחרו מקורות",
  "noSourcesSelectedDetails": "השתמשו באיקון %{icon} למעלה כדי לאתר מקורות ולבנות את לוח המחוונים שלכם.",
  "errorLoadingDataSources": "אירעה שגיאה בטעינת רשימת ערכות הנתונים",
  "errorLoadingDataTree": "אירעה שגיאה בטעינת העץ",
  "dataSetPaneLastUpdated": "עדכון אחרון: %{date}",
  "dataSourcePaneDateUnknown": "לא ידוע",
  "moreTitle": "עוד",
  "backLabel": "חזרה",
  "addDataSourceDialogTitle": "הוספת מקור נתונים",
  "addDataSourceDialogButtonLabel": "הוספה",
  "dlg_use": "שימוש",
  "dlg_RelinkDataSourceTitle": "החלפת ערכת הנתונים '%{dataSourceName}' עם.. ‏",
  "propertiesDialogTitle": "תכונות",
  "missingDataSetData": "הנתונים עבור ערכת נתונים זו אינם זמינים. רעננו את ערכת הנתונים או פנו למנהלן כדי לקבל גישה למקור.",
  "errorLoadingSource": "המטא-נתונים עבור '%{sourceName}'לא נטענו. פנו אל המנהלן כדי לקבל פרטים.",
  "errorMessageTitle": "שגיאה",
  "calculation_in_use": "מחיקת חישוב תגרום לכך שכל ההמחשות המאזכרות אותו יהיו לא חוקיות"
});
